<div [formGroup]="form">

  <div fxLayout="row" fxLayoutGap="16px">
    <mat-form-field fxFlex="30">
      <input matInput formControlName="rowField1">
    </mat-form-field>
    <mat-form-field fxFlex="30">
      <input matInput formControlName="rowField2">
    </mat-form-field>
    <mat-form-field fxFlex="30">
      <input matInput formControlName="rowField3">
    </mat-form-field>
    <div fxFlex="150px" fxLayout="row">
      <button mat-mini-fab color="primary" (click)="clickAddSubRow()"><mat-icon>plus_one</mat-icon></button>
      <button mat-mini-fab color="warn" (click)="clickDelete.emit(null)"><mat-icon>delete</mat-icon></button>
    </div>
  </div>


  <ng-container *ngFor="let rowCtrl of formArray.controls; let j = index;">
    <app-form-sub-row [form]="rowCtrl" [index]="j" (clickDelete)="clickDeleteSubRow(j)"></app-form-sub-row>
  </ng-container>

</div>
